import React, { createContext, useContext, useMemo } from 'react';
const BackgroundContext = createContext({
    backgroundType: 'main',
    backgroundClsx: ['bg-main-50'],
    text400Clsx: ['text-basicMain-400'],
    text500Clsx: ['text-basicMain-500'],
    text900Clsx: ['text-basicMain-900'],
});
export const BackgroundProvider = ({ backgroundType, children, }) => {
    const value = useMemo(() => {
        const backgroundClsx = [
            backgroundType === 'main' && 'bg-main-50',
            backgroundType === 'surface' && 'bg-surface-50',
            backgroundType === 'secondary' && 'bg-actionSecondary-50',
        ];
        const text500Clsx = [
            backgroundType === 'main' && 'text-basicMain-500',
            backgroundType === 'surface' && 'text-basicSurface-500',
            backgroundType === 'secondary' && 'text-basicSecondary-500',
        ];
        const text400Clsx = [
            backgroundType === 'main' && 'text-basicMain-400',
            backgroundType === 'surface' && 'text-basicSurface-400',
            backgroundType === 'secondary' && 'text-basicSecondary-400',
        ];
        const text900Clsx = [
            backgroundType === 'main' && 'text-basicMain-900',
            backgroundType === 'surface' && 'text-basicSurface-900',
            backgroundType === 'secondary' && 'text-basicSecondary-900',
        ];
        return {
            backgroundType,
            backgroundClsx,
            text400Clsx,
            text500Clsx,
            text900Clsx,
        };
    }, [backgroundType]);
    return (React.createElement(BackgroundContext.Provider, { value: value }, children));
};
export const useBackgroundContext = () => {
    return useContext(BackgroundContext);
};
//# sourceMappingURL=BackgroundContext.js.map